module.exports = __webpack_public_path__ + "static/img/icon_yfgk.ee5bee99.png";